export const meta = {
  title: 'The queue board: run your line without the whiteboard',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'pos', 'staff'],
};

The queue board is the live heart of your dashboard. It updates in real time on every device that has it open — cashier counter, washer tablet, your phone.

## The three columns

Every active ticket lives in one of three columns:

- **In queue** — booked, waiting for a bay. Tickets show their position in line.
- **In washing process** — currently being washed.
- **Ready for collection** — washed, waiting for the customer to pay and collect.

Each card shows the ticket number, package, plate, and total. When the queue column is empty, there's nothing to manage — new bookings appear the moment a customer scans your QR.

## Start next

The **Start next** button sits at the top of the In-queue column and always names the ticket at the front of the line. One tap moves that ticket into washing. If your washers only ever use one button, it's this one.

You can also tap **Start** on any individual card to jump a specific car in — the button works the same, it just doesn't have to be the front of the line.

## Reordering the line

Every card in the In-queue column has **up and down arrows** on its left edge. Each tap moves the ticket one place. The customer's live position updates instantly in their app.

There is no drag-and-drop — on a wet-finger tablet, deliberate single taps beat accidental drags.

## Hold and resume

Customer booked, then walked off to lunch? Tap **Hold** on their card. The ticket leaves the line and parks in the **On hold** section at the bottom of the In-queue column, so the cars behind it move up.

When the customer returns, tap **Resume**. The ticket rejoins the queue **at the end of the line** — not its old spot. If you want to give it priority, bump it forward with the up arrow. This is deliberate: the people who kept waiting shouldn't silently lose their place.

## Ready, collected, cancelled

- **Ready** moves a washing ticket to Ready for collection and notifies the customer their car is done.
- **Collected** is the final tap — it archives the ticket into history, where reports and loyalty pick it up. Payment is confirmed on the POS screen.
- **Cancel** is available while a ticket is queued, washing, or on hold. A ticket that's ready for collection can't be cancelled from the board — settle it at the POS instead.

## More than one outlet?

The **outlet switcher** at the top of the board flips the whole view between your locations. Each outlet has its own queue, its own QR code, and its own ticket numbers.

## What the customer sees

Every move you make on the board reflects in the customer's app. They see their position in line, and they get a notification at each step — when they join the queue, when their wash starts, when the car is ready, and if you hold or cancel their ticket. No more shouting plate numbers across the lot.
